import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.ORDER_ITEM,
  primaryKey: 'id',
  properties: {
    id: 'int',
    product: 'Product',
    amount: 'double',
    discount: 'double?',
    price: 'double?',
    buyPrice: 'double?',
    order: 'Order'
  }
};
